import React from'react'
import './Contactus.sass'
import smoothScrollIntoView from 'scroll-into-view-if-needed'

function Contactus (props) {
    const scrollToId = (id) => {
        const el = document.getElementById(id)
        smoothScrollIntoView(el, {behavior: 'smooth', block: 'start'})
    }
      
    return (
        <div id="contactus" className="contactus">
            <div className="container concu">
                <div className="row row10">
                    <div className="col col101 headingcu">
                        <p className="contacthead">{props.text.title}</p>
                    </div>
                </div>
                <div className="row row11 d-flex align-self-baseline justify-content-around ">
                    <div className="col-12 col-lg-4 col111">
                        <h2 dangerouslySetInnerHTML={{__html: props.text.emailTitle}}></h2>
                        <div dangerouslySetInnerHTML={{__html: props.text.emailText}}></div>
                        <p><a href="mailto:info@frosteq.com" className="mail-link"> info@frosteq.com</a></p>
                    </div>
                    <div className="col-12 col-lg-4 col112">
                        <h2 dangerouslySetInnerHTML={{__html: props.text.visitUsTitle}}></h2>
                        <div dangerouslySetInnerHTML={{__html: props.text.visitUsText}}></div>  
                    </div>
                    <div className="col-12 col-lg-4 col113">
                        <h2 dangerouslySetInnerHTML={{__html: props.text.infoTitle}}></h2>
                        <div dangerouslySetInnerHTML={{__html: props.text.infoText}}></div>
                    </div>
                </div>
            </div>
            <div className="footer">
                <div className="container">
                    <div className="row d-flex align-items-center justify-content-center">
                        <button className="fotbtn" onClick={()=>scrollToId('root')}>
                            <div className="arrow"></div>
                        </button>
                    </div>
                    <div className="row rowfot d-flex align-items-center justify-content-center">
                        <div className="fotline"></div>  
                    </div>
                    <div className="row rowbot d-flex align-items-center justify-content-center">
                        <p>{props.text.footer.infoText}</p>
                    </div>
                </div>
            </div>
        </div>
    )
  }
  
  export default Contactus